import HttpClient from "./HttpClient";

export default class Template{

    static async loadTemplate(templateId){
        const client = new HttpClient();
        const response = await client.instance.get(`templates/${templateId}`);
        return response.data;
    }

    static async createTemplate(data){
        const client = new HttpClient();
        const response = await client.instance.post("templates", data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return response.data;
    }
}